import { render, staticRenderFns } from "./dashBroad.vue?vue&type=template&id=46b251bc&scoped=true"
import script from "./dashBroad.vue?vue&type=script&lang=js"
export * from "./dashBroad.vue?vue&type=script&lang=js"
import style0 from "./dashBroad.vue?vue&type=style&index=0&id=46b251bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b251bc",
  null
  
)

export default component.exports